import { Sparkles, CornerDownLeft } from 'lucide-react';

export function CommandBarAiCard({ aiResult, isSelected, getIntentLabel, query, onExecute }) {
  return (
    <button
      data-testid="commandbar-ai-result"
      onClick={onExecute}
      className="w-full flex items-start gap-3 px-5 py-4 text-left transition-colors duration-150"
      style={{
        background: isSelected ? 'var(--pd-panel-2)' : 'transparent',
        borderLeft: '3px solid var(--pd-focus)',
      }}
    >
      <Sparkles className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: 'var(--pd-focus)' }} />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium" style={{ color: 'var(--pd-text)' }}>
          {getIntentLabel(aiResult.intent)}: {aiResult.data?.title || aiResult.data?.targetView || aiResult.data?.url || query}
        </div>
        <div className="text-xs mt-1" style={{ color: 'var(--pd-muted)' }}>
          {aiResult.data?.businessShortCode ? `${aiResult.data.businessShortCode} \u00b7 ` : ''}
          {aiResult.data?.priority ? `${aiResult.data.priority} \u00b7 ` : ''}
          {aiResult.data?.dueDate ? `Due ${aiResult.data.dueDate} \u00b7 ` : ''}
          AI suggested action
        </div>
      </div>
      <span className="kbd-pill"><CornerDownLeft className="w-3 h-3" /></span>
    </button>
  );
}

export function CommandBarResultItem({ result, isSelected, onSelect }) {
  return (
    <button
      key={`${result.group}-${result.title}`}
      data-testid={`commandbar-result-${result.index}`}
      onClick={onSelect}
      className="w-full flex items-start gap-3 px-5 py-3 text-left transition-colors duration-150"
      style={{ background: isSelected ? 'var(--pd-panel-2)' : 'transparent' }}
    >
      <span style={{ color: 'var(--pd-muted)' }}>{result.icon}</span>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.12em]" style={{ color: 'var(--pd-subtle)' }}>{result.group}</div>
        <div className="text-sm mt-1" style={{ color: 'var(--pd-text)', fontWeight: 500 }}>{result.title}</div>
        {result.subtitle ? <div className="text-xs mt-1" style={{ color: 'var(--pd-subtle)' }}>{result.subtitle}</div> : null}
      </div>
    </button>
  );
}

const SUGGESTION_PROMPTS = [
  'Call Ravi at 3 PM',
  'Save this payment for Friday',
  'Open the analytics dashboard',
  'Plan my day around deep work',
];

export function CommandBarHints({ onSuggest }) {
  return (
    <div className="px-5 py-5 space-y-4">
      <div className="rounded-[24px] p-4" style={{ background: 'var(--pd-panel)', border: '1px solid var(--pd-border)' }}>
        <div className="text-[10px] uppercase tracking-[0.12em] font-semibold" style={{ color: 'var(--pd-subtle)' }}>What this bar is for</div>
        <p data-testid="commandbar-preview-copy" className="text-[12px] mt-3" style={{ color: 'var(--pd-muted)', lineHeight: 1.8 }}>
          Jump between views, create items quickly, or ask PolkDesQ to translate natural language into actions.
        </p>
      </div>
      <div className="rounded-[24px] p-4" style={{ background: 'var(--pd-panel-2)', border: '1px solid var(--pd-border)' }}>
        <div className="text-[10px] uppercase tracking-[0.12em] font-semibold" style={{ color: 'var(--pd-subtle)' }}>Try asking</div>
        <div className="grid gap-2 mt-3">
          {SUGGESTION_PROMPTS.map((prompt) => (
            <button
              key={prompt}
              data-testid={`commandbar-suggestion-${prompt.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
              onClick={() => onSuggest(prompt)}
              className="text-left rounded-2xl px-3 py-2 btn-ghost text-[12px]"
            >
              {prompt}
            </button>
          ))}
        </div>
      </div>
      <div className="flex items-center gap-4 text-[11px]" style={{ color: 'var(--pd-subtle)' }}>
        <span className="flex items-center gap-1"><span className="kbd-pill">↑↓</span> Navigate</span>
        <span className="flex items-center gap-1"><span className="kbd-pill">↵</span> Execute</span>
        <span className="flex items-center gap-1"><span className="kbd-pill">Esc</span> Close</span>
      </div>
    </div>
  );
}
